import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1 className="hero-title">
          Building Tomorrow's
          <span className="highlight"> Solutions Today</span>
        </h1>
        <p className="hero-subtitle">
          Transform your business with our cutting-edge services and expertise.
          We deliver excellence in every project.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={scrollToContact}>
            Get Started
          </button>
          <button className="btn btn-secondary" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
            Our Services
          </button>
        </div>
      </div>
      <div className="hero-background">
        <div className="animated-shape shape-1"></div>
        <div className="animated-shape shape-2"></div>
        <div className="animated-shape shape-3"></div>
      </div>
    </section>
  );
};

export default Hero;
